module.exports = __webpack_public_path__ + "static/media/host-club.f99aea8d.jpg";